module.exports = __webpack_public_path__ + "img/about_block_1.16677817.jpg";